import script from "./MonyxBanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./MonyxBanner.vue?vue&type=script&setup=true&lang=ts"

import "./MonyxBanner.vue?vue&type=style&index=0&id=7552b1ea&lang=css"

const __exports__ = script;

export default __exports__